import Types from 'types/types'

/**
 * List of Columns
 * @type {import('types/column').Column[]}
 * @readonly
 */
const emailTemplateColumns = [
    {
        fieldName: 'name',
        name: 'Nom',
        type: Types.STRING,
    },
    {
        fieldName: 'subject',
        name: 'Sujet',
        type: Types.STRING,
    },
    // {
    //     fieldName: 'content',
    //     name: 'Contenu',
    //     type: Types.STRING_LONG,
    // },
]

export default emailTemplateColumns
